<section class="pricing-faq-section">
  <div class="container">
    <p class="section-label text-center">Pricing FAQ</p>
    <h2 class="faq-title text-center">Questions boards ask before a demo</h2>
    <p class="faq-intro text-center">
      Straight answers on plans, support, getting started, fees, and membership counts.
    </p>

    <div class="faq-wrap">
      <mat-accordion class="faq-accordion" multi>
        <mat-expansion-panel *ngFor="let faq of faqs" class="faq-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ faq.question }}</mat-panel-title>
          </mat-expansion-panel-header>
          <p class="faq-answer">{{ faq.answer }}</p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <p class="faq-cta text-center">
      Still deciding?
      <a routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }">Book a personalized demo</a>
      and we will map the right package to your workflows.
    </p>
    <p class="faq-cta text-center">
      Reviewing vendors for your board?
      <a routerLink="/security">See how MemberTrace handles security and data</a>.
    </p>
  </div>
</section>
